import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];
  private isFromBrowserBackForward = false;
  private location = inject(Location);
  private readonly maxHistory = 10;
  private router = inject(Router);

  constructor() {
    this.location.onUrlChange(() => this.isFromBrowserBackForward = true);
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      const url = event.urlAfterRedirects;
      if (this.isFromBrowserBackForward) {
        const didUserWentBack = this.history.at(-2) === url;
        if (didUserWentBack) {
          this.history.pop();
        } else {
          this.pushToHistory(url);
        }
      } else {
        if (this.history.at(-1) !== url) {
          this.pushToHistory(url);
        }
      }
      this.isFromBrowserBackForward = false;
    });
  }

  goBack(fallbackUrl: string): void {
    if (this.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl(fallbackUrl);
    }
  }

  private pushToHistory(url: string): void {
    this.history.push(url);
    if (this.history.length > this.maxHistory) {
      this.history.shift();
    }
  }
}
